import { render, staticRenderFns } from "./HomeBanner.vue?vue&type=template&id=995d5ed4&"
import script from "./HomeBanner.vue?vue&type=script&lang=js&"
export * from "./HomeBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('995d5ed4')) {
      api.createRecord('995d5ed4', component.options)
    } else {
      api.reload('995d5ed4', component.options)
    }
    module.hot.accept("./HomeBanner.vue?vue&type=template&id=995d5ed4&", function () {
      api.rerender('995d5ed4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/HomeBanner.vue"
export default component.exports